<template>
  <span>{{ displayText }}</span>
</template>

<script>
import { ref, watch, onMounted, onUnmounted } from 'vue';

export default {
  name: 'TypeWriter',
  props: {
    text: {
      type: String,
      required: true
    },
    speed: {
      type: Number,
      default: 100
    }
  },
  emits: ['over','scroll'],
  setup(props, { emit }) {
    const displayText = ref('');
    const currentIndex = ref(0);
    let timer = null;
    let stepCount = 0;

    const startTyping = () => {
      stopTyping(); // 清除可能存在的定时器
      currentIndex.value = 0;
      displayText.value = '';
      stepCount = 0;
      if(props.text){
        typeNextChar();
      }
      
    };

    const typeNextChar = () => {
      if (currentIndex.value < props.text.length) {
        timer = setTimeout(() => {
          displayText.value += props.text[currentIndex.value];
          currentIndex.value++;
          typeNextChar();
          stepCount++; 
          if (stepCount >= 10) {
            stepCount = 0;
            console.log('scroll');
            emit('scroll');
          }
        }, props.speed);
      } else {
        emit('over');
      }
    };

    const stopTyping = () => {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    };

    // 监听文本变化，重新开始打字效果
    watch(() => props.text, () => {
       
      startTyping();
    });

    onMounted(() => {
      startTyping();
    });

    onUnmounted(() => {
      stopTyping();
    });

    return {
      displayText
    };
  }
};
</script>

<style scoped>
span {
  white-space: pre-wrap;
}
</style>